var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsev: "http://www.w3.org/2001/xml-events",
    width: "0.26in",
    height: "0.253333in",
    viewBox: "0 0 18.72 18.24",
    xmlSpace: "preserve",
    colorInterpolationFilters: "sRGB",
    className: "st5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st1 {fill:#00b0f0}\n\t\t.st2 {stroke:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.24}\n\t\t.st3 {fill:#00b0f0;stroke:#00b0f0;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.75;visibility:hidden}\n\t\t.st4 {fill:#00b0f0;stroke:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.72}\n\t\t.st5 {fill:none;fill-rule:evenodd;font-size:12px;overflow:visible;stroke-linecap:square;stroke-miterlimit:3}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Page-1"), /*#__PURE__*/React.createElement("g", {
    id: "group52-1",
    transform: "translate(0.36,-0.12)"
  }, /*#__PURE__*/React.createElement("title", null, "Sheet.52"), /*#__PURE__*/React.createElement("g", {
    id: "group14-2",
    transform: "translate(8.13244,-12.9474)"
  }, /*#__PURE__*/React.createElement("title", null, "Open/closed bar.14"), /*#__PURE__*/React.createElement("g", {
    id: "shape15-3"
  }, /*#__PURE__*/React.createElement("title", null, "Sheet.15"), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L9.87 18.24 L9.87 13.19 L0 13.19 L0 18.24 Z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L9.87 18.24 L9.87 13.19 L0 13.19",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape16-6"
  }, /*#__PURE__*/React.createElement("title", null, "Sheet.16"), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L9.87 18.24 L0 18.24 ZM0 13.19 L9.87 13.19 L0 13.19 Z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L9.87 18.24",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.19 L9.87 13.19",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L0 13.19",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87 18.24 L9.87 13.19",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape17-14",
    transform: "translate(-0.36,-0.48)"
  }, /*#__PURE__*/React.createElement("title", null, "Sheet.17"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.1474,
    width: 0.48,
    height: 4.09263,
    className: "st3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape18-16",
    transform: "translate(9.74756,-0.48)"
  }, /*#__PURE__*/React.createElement("title", null, "Sheet.18"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.1474,
    width: 0.48,
    height: 4.09263,
    className: "st3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "group19-18",
    transform: "translate(8.13244,3.55271E-15)"
  }, /*#__PURE__*/React.createElement("title", null, "Open/closed bar.19"), /*#__PURE__*/React.createElement("g", {
    id: "shape20-19"
  }, /*#__PURE__*/React.createElement("title", null, "Sheet.20"), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L9.87 18.24 L9.87 13.19 L0 13.19 L0 18.24 Z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L9.87 18.24 L9.87 13.19 L0 13.19",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape21-22"
  }, /*#__PURE__*/React.createElement("title", null, "Sheet.21"), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L9.87 18.24 L0 18.24 ZM0 13.19 L9.87 13.19 L0 13.19 Z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L9.87 18.24",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.19 L9.87 13.19",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L0 13.19",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87 18.24 L9.87 13.19",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape22-30",
    transform: "translate(-0.36,-0.48)"
  }, /*#__PURE__*/React.createElement("title", null, "Sheet.22"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.1474,
    width: 0.48,
    height: 4.09263,
    className: "st3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape23-32",
    transform: "translate(9.74756,-0.48)"
  }, /*#__PURE__*/React.createElement("title", null, "Sheet.23"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.1474,
    width: 0.48,
    height: 4.09263,
    className: "st3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape43-34",
    transform: "translate(-12.4058,13.5784) rotate(-90)"
  }, /*#__PURE__*/React.createElement("title", null, "Feedback arrow"), /*#__PURE__*/React.createElement("path", {
    d: "M10.23 18.24 L0 18.24 L5.12 12.41 L10.23 18.24 Z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group44-36",
    transform: "translate(5.83416,-6.63158)"
  }, /*#__PURE__*/React.createElement("title", null, "Open/closed bar.44"), /*#__PURE__*/React.createElement("g", {
    id: "shape45-37"
  }, /*#__PURE__*/React.createElement("title", null, "Sheet.45"), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L12.17 18.24 L12.17 13.19 L0 13.19 L0 18.24 Z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L12.17 18.24 L12.17 13.19 L0 13.19",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape46-40"
  }, /*#__PURE__*/React.createElement("title", null, "Sheet.46"), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L12.17 18.24 L0 18.24 ZM0 13.19 L12.17 13.19 L0 13.19 Z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L12.17 18.24",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.19 L12.17 13.19",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.24 L0 13.19",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.17 18.24 L12.17 13.19",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape47-48",
    transform: "translate(-0.36,-0.48)"
  }, /*#__PURE__*/React.createElement("title", null, "Sheet.47"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.1474,
    width: 0.48,
    height: 4.09263,
    className: "st3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape48-50",
    transform: "translate(12.0458,-0.48)"
  }, /*#__PURE__*/React.createElement("title", null, "Sheet.48"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.1474,
    width: 0.48,
    height: 4.09263,
    className: "st3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCollapse);
export default __webpack_public_path__ + "static/media/FilterCollapse.dd84ec5bd55f123ea12c9190d9891c21.svg";
export { ForwardRef as ReactComponent };